/**
 * @version 1.1
 * @author Kelnik Studios {http://kelnik.ru}
 * @link https://kelnik.gitbooks.io/kelnik-documentation/content/front-end/components/alert-old-browser.html documentation
 */

/**
 * DEPENDENCIES
 */
import merge from 'lodash/merge';

class AlertOldBrowser {
    init(options) {
        this.setSettings(options);
        this.checkBrowserName();
    }
    // eslint-disable-next-line
    getBrowser() {
        const ua = navigator.userAgent;
        // eslint-disable-next-line consistent-return,func-names
        let bName = (function() {
            if (ua.search(/Edge/) > -1) {
                return 'edge';
            }
            if (ua.search(/MSIE/) > -1) {
                return 'ie';
            }
            if (ua.search(/Trident/) > -1) {
                return 'ie11';
            }
            if (ua.search(/Firefox/) > -1) {
                return 'firefox';
            }
            if (ua.search(/Opera/) > -1) {
                return 'opera';
            }
            if (ua.search(/OPR/) > -1) {
                return 'operaWebkit';
            }
            if (ua.search(/YaBrowser/) > -1) {
                return 'yabrowser';
            }
            if (ua.search(/Chrome/) > -1 || (ua.search(/CriOS/) > -1)) {
                return 'chrome';
            }
            if (ua.search(/Safari/) > -1) {
                return 'safari';
            }
            if (ua.search(/Maxthon/) > -1) {
                return 'maxthon';
            }
        }());
        // eslint-disable-next-line init-declarations
        let version;

        switch (bName) {
            case 'edge':
                version = ua.split('Edge')[1].split('/')[1];
                break;
            case 'ie':
                version = ua.split('MSIE ')[1].split(';')[0];
                break;
            case 'ie11':
                bName = 'ie';
                version = ua.split('; rv:')[1].split(')')[0];
                break;
            case 'firefox':
                version = ua.split('Firefox/')[1];
                break;
            case 'opera':
                version = ua.split('Version/')[1];
                break;
            case 'operaWebkit':
                bName = 'opera';
                version = ua.split('OPR/')[1];
                break;
            case 'yabrowser':
                version = ua.split('YaBrowser/')[1].split(' ')[0];
                break;
            case 'chrome':
                let separator = 'Chrome/'; // eslint-disable-line

                if (ua.search(/CriOS/) > -1) {
                    separator = 'CriOS/';
                }

                version = ua.split(separator)[1].split(' ')[0];
                break;
            case 'safari':
                version = ua.split('Version/')[1].split(' ')[0];
                break;
            case 'maxthon':
                version = ua.split('Maxthon/')[1];
                break;
            default:
                break;
        }
        let platform = 'desktop';

        if ((/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase())) {
            platform = 'mobile';
        }
        let browsrObj = null;

        try {
            browsrObj = {
                platform,
                browser     : bName,
                versionFull : version,
                versionShort: version.split('.')[0]
            };
        } catch (err) {
            browsrObj = {
                platform,
                browser     : 'unknown',
                versionFull : 'unknown',
                versionShort: 'unknown'
            };
        }

        return browsrObj;
    }

    setSettings(options) {
        const defaultBrowserSupport = [{
            name   : 'chrome',
            version: 57
        }, {
            name   : 'firefox',
            version: 53
        }, {
            name   : 'opera',
            version: 44
        }, {
            name   : 'ie',
            version: 12
        }, {
            name   : 'safari',
            version: 11
        }, {
            name   : 'android',
            version: 5
        }, {
            name   : 'ios',
            version: 10
        }];

        this.supportBrowsers = merge(defaultBrowserSupport, options);
        this.userBrowser = this.getBrowser();
        this.body = document.body;
        this.popup = null;
        this.closeButton = null;
    }

    /**
     * Вешаем слушателей событий
     */
    bindEvents() {
        const that = this;

        $(document).on('click', this.closeButton, () => {
            this.removePopup();
        });
        this.ignoreButton.on('click', this.removePopup.bind(this));
        this.popup.on('click', (element) => {
            if (element.target === that.popup) {
                that.removePopup();
            }
        });
    }

    /**
     * Определение имени браузера
     */
    checkBrowserName() {
        this.supportBrowsers.forEach((item) => {
            if (this.userBrowser.browser === item.name) {
                this.checkBrowserVersion(item);
            }
        });
    }

    /**
     * Определение версии браузера
     * @param {Object} supportBrowser -Сопоставленая версия браузера из настроек.
     */
    checkBrowserVersion(supportBrowser) {
        if (this.userBrowser.versionShort < supportBrowser.version) {
            if (this.userBrowser.versionShort <= 10) {
                $('html, body').addClass(`old-browser ${this.userBrowser.browser}-${this.userBrowser.versionShort}`);
                this.showPopup();
            } else {
                this.showPopup();
            }
        }
    }

    /**
     * Получение элементов окна
     */
    getElements() {
        this.popup = $('.b-alert-old-browser');
        this.closeButton = '.b-alert-old-browser__close';
        this.ignoreButton = $('.b-alert-old-browser__ignore-button');
        this.popup.removeClass('is-hidden');
    }

    /**
     * Показываем изображения
     */
    showImages() {
        const images = this.popup[0].querySelectorAll('img');

        if (images) {
            for (let i = 0; i < images.length; i++) {
                const targetAttribute = images[i].nodeName === 'SOURCE' ? 'srcset' : 'src';
                const sourceElement = images[i].nodeName === 'SOURCE' ? 'data-srcset' : 'data-src';

                if (images[i].getAttribute(sourceElement)) {
                    images[i].setAttribute(targetAttribute, images[i].getAttribute(sourceElement));
                    images[i].removeAttribute(sourceElement);
                }
            }
        }
    }

    /**
     * Открытие попапа
     */
    showPopup() {
        this.getElements();
        this.bindEvents();
        this.showImages();
    }

    /**
     * Удаление попапа
     */
    removePopup() {
        this.popup.addClass('is-hidden');
        $('html, body').removeClass(`old-browser`);
    }

    addScript(src) {
        const script = document.createElement('script');

        script.src = src;
        script.async = false;
        document.body.appendChild(script);
    }
}

export default AlertOldBrowser;

const alertOldBrowser = new AlertOldBrowser();
// const ver = $('script[src*="alert.js"]').attr('src')
//     .split('?')[1];

alertOldBrowser.init();
// alertOldBrowser.addScript(`/scripts/app.js?${ver}`);
